export const paths = {
  OVERVIEW: 'overview',
  DETAILS: 'details',
  SIGNATURE: 'signature',
  INTERVENTIONS: 'interventions',
  CONFIRMATION: 'confirmation',
}
